// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"47":"3ada0232","313":"528697b9"}[chunkId] + ".css";
};